<template>
  <div class="question">
    <titleBar :title="'常见问题'"  :callback="true" @callback="goBack"></titleBar>
    <p class="tit" style="margin-top:0.88rem;">1、已经坚持阅读306天，如何申请返学费？</p>
    <p class="con">
      在【我的】-【我的打卡】处，点击学习进度，在该页面中可以申请返还学费。
    </p>
    <p class="tit">2、如何看到自己参与活动后，累计学习了多少天？</p>
    <p class="con">
      在【我的】页面，我的打卡模块中，可以找到当前累计的学习天数
    </p>
    <p class="tit">3、后续上新内容还会再收费吗？</p>
    <p class="con">不会，在会员有效期内，可以无限次畅学全部内容。</p>
    <p class="tit">4、赠送的学霸礼包，什么时候发货，我怎样能看到物流信息？</p>
    <p class="con">
      在【我的】-【我的打卡】处，点击学习进度进入的页面里可以看到。
    </p>
    <p class="tit">5、购买后可以退款吗？</p>
    <p class="con">会员属于虚拟商品，不支持退款。</p>
  </div>
</template>
<script>
import titleBar from "@/components/common/titleBar.vue";
export default {
  name: "questiontip",
  components: {
    titleBar,
  },
  methods:{
    goBack(){
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>

.question {
  padding: .98rem .4rem 0;
  background: #fff;
  height:100%;
  position: fixed;
  top:0;
  bottom:0;
}
.title {
  color: #161616;
  font-size: .32rem;
  text-align: center;
  line-height: .8rem;
}
.tit {
  font-size: .34rem;
  line-height: .6rem;
  margin: .12rem 0;
}
.con {
  color: #919294;
  line-height: .56rem;
  font-size: .32rem;
  // text-indent: 20rem;
}
</style>
